import Button from '@atlaskit/button/standard-button';
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle, ModalTransition } from '@atlaskit/modal-dialog';
import { EntitlementGroup, EntitlementDetails } from '@css-xp/graphtypes/src/generated-types-new';
import { NEW_DATE_FORMAT } from '@atlassian/cssxp-typescommon';
import React, { useCallback } from 'react';
import { Icon } from '../../../icon';

import { FormattedDate } from '../../../formatted';

import './warning-dialog.scss';

export const CoBillWarningDialog = ({
  isOpen,
  onClose,
  onConfirm,
  entitlement,
  selectedDate,
  existingEntitlements,
  isRelationshipExists,
}: {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  entitlement: EntitlementDetails;
  selectedDate: string;
  existingEntitlements: EntitlementGroup[];
  isRelationshipExists: boolean;
}) => {
  const { entitlementNumber, latestPeriodEndDate } = entitlement;

  const getDescription = useCallback(() => {
    const billindDateEntitlements = existingEntitlements
      .filter((entitlementObj) => entitlementObj.billingDate === selectedDate)
      .map((entitlementObj) => entitlementObj.entitlements);
    const baseContent = (
      <span>
        {`Bill date of ${entitlementNumber} will change from `}
        <FormattedDate date={latestPeriodEndDate} format={NEW_DATE_FORMAT} />
        {` to `} <FormattedDate date={selectedDate} format={NEW_DATE_FORMAT} />
      </span>
    );
    if (billindDateEntitlements && billindDateEntitlements?.length > 0) {
      return (
        <div>
          {baseContent}
          <div>
            <br />
            <ul className="entitlement-list-data">
              {isRelationshipExists && (
                <li>
                  The bill date will also change for other product and app subscriptions on this site that belong to the
                  same product family.
                </li>
              )}
              <li>It will be co-billed with other selected subscriptions.</li>
              <li>Pro-rata adjustments will be applied to the next invoice.</li>
            </ul>
          </div>
        </div>
      );
    }
    if (isRelationshipExists) {
      return (
        <div>
          {baseContent}
          <div>
            <br />
            <ul className="entitlement-list-data">
              {isRelationshipExists && (
                <li>
                  The bill date will also change for other product and app subscriptions on this site that belong to the
                  same product family.
                </li>
              )}
              <li>Pro-rata adjustments will be applied to the next invoice.</li>
            </ul>
          </div>
        </div>
      );
    }
    return (
      <div>
        {baseContent}
        <div>
          <br />
          {`Pro-rata adjustments will be applied to the next invoice.`}
        </div>
      </div>
    );
  }, [entitlementNumber, latestPeriodEndDate, selectedDate, existingEntitlements, isRelationshipExists]);

  return (
    <ModalTransition>
      {isOpen && (
        <Modal onClose={onClose}>
          <ModalHeader>
            <ModalTitle>
              <Icon type="warning" /> <span className="warning-confirm-header">{`Confirm bill date change`}</span>
            </ModalTitle>
          </ModalHeader>
          <ModalBody>{getDescription()}</ModalBody>
          <ModalFooter>
            <div id="warning-confirm-footer">
              <Button appearance="subtle" onClick={onClose} className="cancel-button" testId="cancel-warning-dialog">
                Cancel
              </Button>
              <Button
                appearance="warning"
                onClick={onConfirm}
                autoFocus
                testId="change-warning-dialog"
                aria-label="Change bill date"
              >
                Confirm
              </Button>
            </div>
          </ModalFooter>
        </Modal>
      )}
    </ModalTransition>
  );
};
